<template>

    <div id="lottery-box" class="relative change-BG" @click="nextLottery" v-if="isDrawable">

        <div class="mo-show">
            <img class="absolute" :src="luckyboxStore.getAsset('images/event/2026luckybox/game-BG-mo1.png')" alt="" />
            <img class="absolute change-ani" :src="luckyboxStore.getAsset('images/event/2026luckybox/game-BG-mo2.png')" alt="" />
        </div>
        <div class="pc-show">
            <img class="absolute " :src="luckyboxStore.getAsset('images/event/2026luckybox/game-BG.png')" alt="" />
            <img class="absolute change-ani" :src="luckyboxStore.getAsset('images/event/2026luckybox/game-BG02.png')" alt="" />
            <img class="absolute " :src="luckyboxStore.getAsset('images/event/2026luckybox/game-BG03.png')" alt="" />
        </div>

        <div class="absolute four-encelope-part flex items-center justify-center">
            <!--抽紅包-->
            <div class="text-center w1160" :style="{
                'cursor': isDrawable ? 'pointer' : 'not-allowed',
            }">
                <div class="red-unber-BG text-center">
                    <div>※購買福箱即可參加抽紅包活動</div>
                        <!--抽紅包次數-->
                    <div class="text-2xl" v-if="isDrawable">
                        <span>你還可以抽&nbsp;</span>
                        <span>{{ campaign.remaining_draw_count }}</span>
                        <span>&nbsp;次紅包</span>
                    </div>
                </div>

                <div class="grid grid-2-4" style="position: relative;">

                    <div class="is-drawing" v-if="isDrawing">
                        <ProgressSpinner style="width: 200px; height: 200px" strokeWidth="5" fill="transparent" />
                    </div>

                    <!-- 點選後-紅包狀態 -> red-envelope-BG BGimg01 加 is-open -->
                    <template v-for="(envelope, index) in envelopes" :key="envelope">
                        <div class="flex items-center justify-center call-confetti red-envelope"
                            :class="getEnvelopeClass(envelope)"
                            @click="openEnvelope($event, envelope)">
                            <div class="red-envelope-txt">
                                <div class="">\恭喜您抽中/</div>
                                <div class="white">折價券</div>
                                <div class="g-gold">{{ lotteryPrize }}</div>
                                <div class="" v-if="isDrawable">點擊後繼續</div>
                            </div>
                        </div>
                    </template>


                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.is-not-drawable {
    cursor: not-allowed;
    pointer-events: none;
}
.is-gray {
    pointer-events: none;
}
.is-waiting {
    cursor: wait;
    pointer-events: none;
}
.is-drawing {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
}
</style>

<script setup>
import ApiClient from '../../../composables/api_client';
import { ref, computed } from 'vue';
import { toNumeric } from '../../../composables/utils';
import { useGlobalStore } from '../../../stores/useGlobalStore';
import { storeToRefs } from 'pinia';
import { useLuckyboxStore } from '../../../stores/useLuckyboxStore';

import { ProgressSpinner } from 'primevue';
import { useWindowScroll } from '@vueuse/core';

const globalStore = useGlobalStore();
const luckyboxStore = useLuckyboxStore();
const { states, campaign } = storeToRefs(luckyboxStore);

const envelopes = [
    'BGimg01', 'BGimg02', 'BGimg03', 'BGimg04',
];

const lotteryPrize = ref('???');

const isDrawing = ref(false);
const hasOpened = ref(false);
const openIndex = ref(null);

const isDrawable = computed(() => {
    return campaign.value?.remaining_draw_count > 0;
});

const nextLottery = () => {
    const elOpened = document.querySelectorAll('.red-envelope');
    const isOpened = Array.from(elOpened).some((el) => el.classList.contains('is-open'));
    if (!isOpened) {
        return;
    }

    if (isDrawable.value) {
        elOpened.forEach(el => {
            el.classList.remove('is-open', 'is-gray', 'is-not-drawable');
        });
        hasOpened.value = false;
        openIndex.value = null;
    }
};

const openEnvelope = async (e, index) => {

    if (!isDrawable.value) {
        console.warn('已達抽獎上限');
        return;
    }

    const el = e.currentTarget;

    if (el.classList.contains('is-open')) {
        el.classList.remove('is-open', 'is-gray', 'is-not-drawable');
        hasOpened.value = false;
        openIndex.value = null;
        return;
    }

    try {
        isDrawing.value = true;

        const api = route('hc.api.campaigns.play', {
            campaignId: campaign.value.campaign_id,
        });
        const response = await ApiClient.get(api);
        const data = response.data ?? {};
        lotteryPrize.value = data?.lottery_prize;
        campaign.value = data;
        // update state
        hasOpened.value = true;
        openIndex.value = index;

        confetti({
            spread: 180,
            particleCount: 100,
            origin: { y: 1 },
            colors:['#fff66b', '#b3f05d', '#a4e6e8', '#f974a2', '#ffffff']
        });

    } catch (error) {
        console.error(error);
        window.alert(error.message);
    } finally {
        isDrawing.value = false;
    }
};
const getEnvelopeClass = (index) => {
    const css = [
        index
    ];
    if (hasOpened.value && openIndex.value !== index) {
        css.push('is-gray');
    }
    if (openIndex.value === index) {
        css.push('is-open');
    }
    if (!isDrawable.value) {
        css.push('is-not-drawable');
    }
    return css.join(' ');
};

// watch(() => campaign.value, (val) => {
//     campaignId.value = val?.id ?? null;
// }, { immediate: true });
</script>
